var render = function (_h,_vm) {var _c=_vm._c;return _c('fieldset',{class:[
    { 'opacity-50 select-none': _vm.props.disabled },
    _vm.props.disabled && _vm.props.disabledClasses,
    _vm.data.class,
    _vm.data.staticClass ],attrs:{"disabled":_vm.props.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }